import React from "react";

function ReviewsSection(){

return(

<section className="reviews-section">

<h1>Real User Experiences That Speak Louder Than Promises</h1>

<div className="review">

<h3>Rajesh K., Mumbai,</h3>
<p>
“I have visited many cricket ID platforms, but the odds and instant
withdrawals at KaalBet Online are unbeatable. At last, I have found
my betting home forever.”
</p>

<h3>Priya S., Bangalore</h3>
<p>
“The support team has been very patient and helped me get a good
grasp of cricket betting. Within just two months, I have been making
profits regularly thanks to their reliable platform and support.”
</p>

<h3>Amit T., Delhi</h3>
<p>
“Payouts are really super-fast. There were times when my payouts
were done in less than 3 hours! This is very hard to find in the
industry.”
</p>

<h3>Vikram M., Pune</h3>
<p>
“Being a doubter of online betting, the transparent operations and
legal compliance of KaalBet Online made me feel safe to step in.
I have made the best choice.”
</p>

<h3>Suresh L., Hyderabad</h3>
<p>
“The number of betting markets is astonishing. I can place my bets
on everything from the match winner to the performance of a single
player. It is always very thrilling!”
</p>

</div>

</section>

);

}

export default ReviewsSection;